import { useMemo, useState } from "react";
import type { EventRow } from "../types";

type Props = {
  recentEvents: EventRow[];
};

const eventKind = (type: string): "trade" | "risk" | "system" | "config" => {
  if (
    type.includes("approval") ||
    type.includes("order") ||
    type.includes("signal") ||
    type.includes("position")
  ) {
    return "trade";
  }
  if (
    type.includes("limit") ||
    type.includes("halt") ||
    type.includes("breaker") ||
    type.includes("risk")
  ) {
    return "risk";
  }
  if (type.includes("config") || type.includes("wizard")) {
    return "config";
  }
  return "system";
};

export const JournalScreen = ({ recentEvents }: Props) => {
  const [filter, setFilter] = useState<"all" | "trade" | "risk" | "config" | "system">(
    "all",
  );

  const rows = useMemo(
    () =>
      recentEvents.filter((event) => {
        if (filter === "all") return true;
        return eventKind(event.type) === filter;
      }),
    [filter, recentEvents],
  );

  return (
    <div data-screen-label="Journal">
      <div className="tp-page-head">
        <h1>Journal</h1>
        <div className="meta">{recentEvents.length} recent audit events</div>
      </div>

      <div className="tp-actionbar">
        {(["all", "trade", "risk", "config", "system"] as const).map((id) => (
          <button
            key={id}
            type="button"
            className={"tp-chip-btn" + (filter === id ? " active" : "")}
            onClick={() => setFilter(id)}
          >
            {id}
          </button>
        ))}
      </div>

      <div className="tp-tile">
        <div className="tp-tile-head">
          <span className="label">Audit timeline</span>
          <span className="tp-muted">source: hash-chained events</span>
        </div>
        <div className="tp-tile-body">
          {rows.length === 0 ? (
            <div className="tp-empty-state">No events match this filter.</div>
          ) : (
            <div className="tp-journal-list">
              {rows.map((event, i) => {
                const kind = eventKind(event.type);
                return (
                  <div
                    key={`${event.time}-${event.type}-${i}`}
                    className={`tp-journal-row ${kind}`}
                  >
                    <div className="time num">{event.time}</div>
                    <div>
                      <div className="type num">{event.type}</div>
                      <div className="summary">{event.summary}</div>
                    </div>
                    <div className="actor num">{event.actor}</div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
